import { Component, ViewChild, OnInit, OnDestroy, AfterViewInit } from '@angular/core';

import { Observable } from 'rxjs';

import { MatPaginator } from '@angular/material/paginator';
import { fuseAnimations } from '@fuse/animations';
import { AuthService } from 'app/services/auth.service';
import { UserModel } from 'app/models/user.model';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
// PIVOT VIEW
import {ActivatedRoute, ActivationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {FuseNavigationService} from "../../../@fuse/components/navigation/navigation.service";
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { LanguageService } from 'app/services/language.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-home',
    templateUrl: './selected-tenant.component.html',
    styleUrls: ['./selected-tenant.component.scss'],
    animations: fuseAnimations
})
export class SelectedTenantComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;

    currentUser: UserModel;

    pageLoading$: Observable<boolean>;
    moduleName: string;
    languages: any;
    selectedLanguage: any;
    constructor(
        private authService: AuthService,
        private fuseProggressBarService: FuseProgressBarService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private _fuseNavigationService: FuseNavigationService,
        private _languageService: LanguageService,
        private _fuseSplashScreenService:FuseSplashScreenService,
        private _translateService: TranslateService,
    ) {
        this.currentUser = this.authService.currentUser;
        this.router.events
          .pipe(
            filter(ev => ev instanceof ActivationEnd),
          )
          .subscribe((ev: ActivationEnd) => {
               if (ev.snapshot?.data?.moduleName) {
                   this.moduleName = ev.snapshot.data.moduleName;
               }
        });

        this.activatedRoute.data.subscribe(data => {
            this._fuseNavigationService.setCurrentNavigation(data.navigation);
        })
    }

    ngAfterViewInit(): void {
    }

    ngOnInit() {
        this.pageLoading$ = this.fuseProggressBarService.visible;   
        if(JSON.parse(localStorage.getItem('roomWebex')).title){
            localStorage.removeItem('roomWebex');
            localStorage.removeItem('tokenWebex'); 
            localStorage.removeItem('jwtTokenWebex');
            localStorage.removeItem('userRoomWebex');
            location.reload();
        }     
    }


    ngOnDestroy() {
    }

    // --------------------------------------
    // ACTIONS
    // --------------------------------------
}
